import React from 'react';
import { Form } from 'react-bootstrap';

const EditableField = ({ field, value, error, onChange }) => {
  const control = () => {
    if (field.type === 'textarea' || field.type === 'richtext') {
      return (
        <Form.Control
          as="textarea"
          rows={field.type === 'richtext' ? 6 : 4}
          value={value}
          isInvalid={!!error}
          onChange={(event) => onChange(event.target.value)}
        />
      );
    }

    if (field.type === 'select') {
      return (
        <Form.Control
          as="select"
          value={value}
          isInvalid={!!error}
          onChange={(event) => onChange(event.target.value)}
        >
          <option value="">Select</option>
          {(field.options || []).map((option) => (
            <option key={typeof option === 'string' ? option : option.value} value={typeof option === 'string' ? option : option.value}>
              {typeof option === 'string' ? option : option.label}
            </option>
          ))}
        </Form.Control>
      );
    }

    return (
      <Form.Control
        type={field.type === 'number' ? 'number' : 'text'}
        value={value}
        isInvalid={!!error}
        onChange={(event) => onChange(event.target.value)}
      />
    );
  };

  return (
    <Form.Group className="narrative-field-card">
      <Form.Label>
        {field.name}
        {field.required && <span className="text-danger ml-1">*</span>}
      </Form.Label>
      {control()}
      {field.helpText && <Form.Text className="text-muted">{field.helpText}</Form.Text>}
      {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
    </Form.Group>
  );
};

export default EditableField;
